module.exports = __webpack_public_path__ + "img/twitter-icon.8ffe180a.png";